import {Columns} from 'compob2b-table';
import {translations} from '../../../../../../../environments/translations.ru';


export const DAM_ITEM_HISTORY_FORM: Columns[] = [
  {
    key: 'fieldName',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: true,
    grid: true,
    type: 'input',
    required: true,
    className: 'formly-full'
  },
  {
    key: 'operationUuid',
    title: translations.operationUuid,
    placeholder: translations.operationUuid,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'changedBy',
    title: translations.login,
    placeholder: translations.login,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'ip',
    title: translations.ip,
    placeholder: translations.ip,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'changeType',
    title: translations.eventType,
    placeholder: translations.eventType,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'oldValue',
    title: translations.oldValue,
    placeholder: translations.oldValue,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'newValue',
    title: translations.newValue,
    placeholder: translations.newValue,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'createdAt',
    title: translations.changedAt,
    placeholder: translations.changedAt,
    searchEnabled: false,
    formly: true,
    grid: true,
    type: 'date',
    required: true,
    defaultValue: new Date(),
    templateOptions: {
      label: translations.createdAt,
      type: 'timestamp',
      required: true,
    },
  },
];
